import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SANHero from "./components/SANHero";
import SANContent from "./components/SANContent";
import SANShopSection from "./components/SANShopSection";
import SANFormula from "./components/SANFormula";
import SANRelated from "./components/SANRelated";
import SANBottomCTA from "./components/SANBottomCTA";

export default function SmallApartmentSoftNeutrals() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <SANHero />
      <SANContent />
      <SANFormula />
      <SANShopSection />
      <SANRelated />
      <SANBottomCTA />
      <Footer />
    </div>
  );
}
